import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SnsSendMessageConditionPanelComponent } from './sns-send-message-condition-panel.component';
import { TooltipModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
  ],
  exports: [
    SnsSendMessageConditionPanelComponent,
  ],
  declarations: [
    SnsSendMessageConditionPanelComponent,
  ]
})
export class SnsSendMessageConditionPanelModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SnsSendMessageConditionPanelModule,
      providers: []
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/condition-panel/sns-send-message-condition-panel.module.ts